export default {
	// api请求地址
	baseUrl: 'https://jikakeji.com',
	// 图片域名
	imgDomain: 'https://jikakeji.com',
	// 腾讯地图key
	mpKey: '',
	// 客服
	webSocket: 'wss://jikakeji.com/wss',
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500,
}